// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__6UCa5","button":"Button_button__2Bqtb","btnLink":"Button_btnLink__2xYxS"};